export function priceParse(v) {
  return parseFloat(v).toFixed(2).toLocaleString("tr-TR") + " TL";
}

export function numberParse(v, fixedValue) {
  return Number(
    Math.round(parseFloat(v + `e${fixedValue}`)) + `e-${fixedValue}`
  ).toLocaleString("tr-TR", {
    maximumFractionDigits: fixedValue,
    minimumFractionDigits: fixedValue,
  });
}

export function formatNumber(num) {
  let x;
  x = num.toString().replace(".", ",");
  var parts = x.toString().split(".");
  return (
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") +
    (parts[1] ? "." + parts[1] : "")
  );
}

export function unFormatNumber(num) {
  if (num) {
    let x, y;
    x = num.replace(".", "");
    y = Number(x.replace(/[,]/g, "."));
    return y;
  }
}

export const convertToDynamicText = (
  txt = "",
  changeHrefParam = "#",
  anchorText = ""
) => {
  let txtArr = txt.split(" ");
  let index = txtArr.indexOf("{0}");
  if (index !== -1) {
    txtArr[index] = <a href={`${changeHrefParam}`}>{anchorText}</a>;
  }

  return (
    <p>
      {txtArr.map((item) => (
        <span>{item} </span>
      ))}
    </p>
  );
};
